import IconStyle from "../templates/Icon.style";
var iconData = {
  name: 'icon',
  data: [],
  onlyTemplate: IconStyle
};
export default iconData;